import { styled } from '@mui/material/styles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { getDrugTestThemeTokens } from '../themeTokens';

export const EmptyRoot = styled('div')(({ theme }) => ({
  textAlign: 'center',
  padding: '56px 32px 40px',
  marginBottom: 16,
  color: getDrugTestThemeTokens(theme).textMuted,
}));

export const EmptyIcon = styled(FontAwesomeIcon)(({ theme }) => ({
  fontSize: 40,
  marginBottom: 12,
  opacity: 0.5,
  color: getDrugTestThemeTokens(theme).textMuted,
}));

export const EmptyTitle = styled('h3')(({ theme }) => ({
  margin: '0 0 8px',
  color: getDrugTestThemeTokens(theme).text,
  fontSize: 17,
  fontWeight: 600,
  lineHeight: 1.3,
}));

export const EmptyBody = styled('p')({
  margin: '0 0 8px',
  fontSize: 14,
  lineHeight: 1.5,
  maxWidth: 520,
  marginLeft: 'auto',
  marginRight: 'auto',
});

export const EmptyHint = styled('p')({
  margin: '0 0 20px',
  fontSize: 13,
  lineHeight: 1.5,
  maxWidth: 520,
  marginLeft: 'auto',
  marginRight: 'auto',
});

export const EmptyActions = styled('div')({
  display: 'flex',
  justifyContent: 'center',
  marginBottom: 16,
});

export const EmptyFooter = styled('p')(({ theme }) => ({
  margin: 0,
  fontSize: 11,
  color: getDrugTestThemeTokens(theme).textFaint,
}));
